import React from "react";
import { WHY_CHOOSE } from "@/data/landing";
import { Check } from "lucide-react";

export default function WhyChoose() {
  return (
    <section className="py-20 md:py-28 border-b border-white/10" data-testid="section-why-choose">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="eyebrow">Why Voltech</div>
        <h2 className="font-display text-3xl md:text-5xl uppercase mt-3 tracking-tighter">
          Built better. Priced direct.
        </h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {WHY_CHOOSE.map((w, i) => (
            <div key={i} className="industrial-card p-6 flex gap-4" data-testid={`why-choose-${i}`}>
              <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-[#e63946]/10 border border-[#e63946]/30">
                <Check size={16} className="text-[#e63946]" />
              </div>
              <div>
                <div className="font-display text-base uppercase leading-tight">
                  {w.title}
                </div>
                <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{w.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
